<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useBranding } from 'shared/composables/useBranding';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { copyTextToClipboard } from 'shared/helpers/clipboard';
import { parseBoolean } from '@chatwoot/utils';
import ChangePassword from './ChangePassword.vue';
import AccessToken from './AccessToken.vue';
import MfaSettingsCard from './MfaSettingsCard.vue';
import ActiveSessions from './ActiveSessions.vue';
import SectionLayout from '../account/components/SectionLayout.vue';

const { t } = useI18n();
const store = useStore();
const { replaceInstallationName } = useBranding();
const currentUser = useMapGetter('getCurrentUser');
const globalConfig = useMapGetter('globalConfig/get');

const isMfaEnabled = computed(() =>
  parseBoolean(window.chatwootConfig?.isMfaEnabled)
);

const onCopyToken = async value => {
  await copyTextToClipboard(value);
  useAlert(t('COMPONENTS.CODE.COPY_SUCCESSFUL'));
};

const resetAccessToken = async () => {
  const success = await store.dispatch('resetAccessToken');
  useAlert(
    success
      ? t('PROFILE_SETTINGS.FORM.ACCESS_TOKEN.RESET_SUCCESS')
      : t('PROFILE_SETTINGS.FORM.ACCESS_TOKEN.RESET_ERROR')
  );
};
</script>

<template>
  <div class="grid">
    <SectionLayout
      v-if="!globalConfig.disableUserProfileUpdate"
      :title="t('PROFILE_SETTINGS.FORM.PASSWORD_SECTION.TITLE')"
      description=""
      class="!pt-0"
    >
      <ChangePassword />
    </SectionLayout>
    <SectionLayout
      v-if="isMfaEnabled"
      with-border
      :title="t('PROFILE_SETTINGS.FORM.SECURITY_SECTION.TITLE')"
      :description="t('PROFILE_SETTINGS.FORM.SECURITY_SECTION.NOTE')"
    >
      <MfaSettingsCard />
    </SectionLayout>
    <SectionLayout
      with-border
      :title="t('PROFILE_SETTINGS.FORM.SESSIONS_SECTION.TITLE')"
      :description="t('PROFILE_SETTINGS.FORM.SESSIONS_SECTION.NOTE')"
    >
      <ActiveSessions />
    </SectionLayout>
    <SectionLayout
      with-border
      :title="t('PROFILE_SETTINGS.FORM.ACCESS_TOKEN.TITLE')"
      :description="
        replaceInstallationName(t('PROFILE_SETTINGS.FORM.ACCESS_TOKEN.NOTE'))
      "
    >
      <AccessToken
        :value="currentUser.access_token"
        @on-copy="onCopyToken"
        @on-reset="resetAccessToken"
      />
    </SectionLayout>
  </div>
</template>
